import { useMemo } from 'react';
import { appPaths } from 'consts/paths/paths';
import { useUserDetails } from 'jotaiAtoms/userDetails';
import { StaffMainAppModules } from 'types';
import { STAFF_APP_MODULES_PATHS } from 'consts/paths/staffAppModulesPaths';
import { NavigateToDefaultPageLayout } from 'components/layouts';

export const NavigateToDefaultPage = () => {
    const { type, role, institutionVerified } = useUserDetails();

    const defaultPagePath = useMemo(() => {
        switch (type) {
            case 'EMPLOYEE': {
                if (institutionVerified === false) {
                    return appPaths.app.account.base;
                }

                const defaultModule = (
                    Object.keys(STAFF_APP_MODULES_PATHS) as StaffMainAppModules[]
                ).find((appModule) => role.modules.includes(appModule));

                if (defaultModule) {
                    return STAFF_APP_MODULES_PATHS[defaultModule];
                }

                return appPaths.error['not-found'];
            }
            case 'PARENT':
                return appPaths.app.parent.news.attendance.base;
            case 'SYS_ADMIN':
                return appPaths.app.admin.institutions.base;
            case 'OWNER':
            case 'SUPPORT_OWNER':
                return institutionVerified === false
                    ? appPaths.app.account.base
                    : appPaths.app.employees.base;
            default:
                return appPaths.error['not-found'];
        }
    }, [institutionVerified, role.modules, type]);

    return <NavigateToDefaultPageLayout to={defaultPagePath} />;
};
